import { render, staticRenderFns } from "./PartnerView.vue?vue&type=template&id=55d2c83e&scoped=true"
import script from "./PartnerView.vue?vue&type=script&lang=js"
export * from "./PartnerView.vue?vue&type=script&lang=js"
import style0 from "./PartnerView.vue?vue&type=style&index=0&id=55d2c83e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d2c83e",
  null
  
)

export default component.exports